import React, { useState } from "react";
import { Button, Grid, Avatar, Typography } from "@mui/material";
import { Formik, Form, Field } from "formik";
import { TextField } from "formik-mui";
import { useNavigate, Link } from "react-router-dom";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import { SignUpSchema } from "@poseidon/utils/authFieldUtils";
import { useAuth } from "@poseidon/ui/components/AuthContext";
import PasswordField from "@poseidon/ui/components/form/PasswordField";

export const SignUp = () => {
  const { signUp } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState();

  return (
    <>
      <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        Register
      </Typography>
      <Formik
        initialValues={{
          email: "",
          password: "",
        }}
        validationSchema={SignUpSchema}
        onSubmit={async (values) => {
          try {
            await signUp(values.email, values.password);
            navigate("/", { replace: true });
          } catch (error) {
            setError(error.code);
          }
        }}
      >
        {({ errors, touched }) => (
          <Form
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              width: "100%",
            }}
          >
            <Field
              autoComplete="email"
              autoFocus
              component={TextField}
              error={errors.email && touched.email ? true : false}
              fullWidth
              id="email"
              label="Email"
              margin="normal"
              name="email"
              required
              type="email"
              helperText={touched.email ? errors.email : null}
            />
            <Field
              autoComplete="current-password"
              component={PasswordField}
              error={errors.password && touched.password ? true : false}
              fullWidth
              id="password"
              label="Password"
              margin="normal"
              name="password"
              required
              helperText={touched.password ? errors.password : null}
            />
            {error && (
              <Typography color="error" mb={1}>
                {error}
              </Typography>
            )}
            <Button
              variant="contained"
              color="primary"
              type="submit"
              margin="normal"
              fullWidth
              sx={{ mt: 3, mb: 2 }}
            >
              Register
            </Button>
          </Form>
        )}
      </Formik>
      <Grid container>
        <Grid item xs>
          <Link to="/auth/login">
            <Typography variant="body2" color="text.secondary">
              Already registered? Login
            </Typography>
          </Link>
        </Grid>
      </Grid>
    </>
  );
};
